<template>
<div>
  <v-row>
    <v-col cols="1"></v-col>
    <v-col cols="10">
      <v-autocomplete
          v-model="key"
          :items="keys"
          clearable
          :loading="loading"
          :search-input.sync="search"
          hide-no-data
          no-filter
          @click:clear="keys = []"
          item-text="oem"
          :item-value="item => item"
          @input = "input"
          label="OEM/FCC/IC/iSKU"
          solo
          return-object
        >
        <v-list-tile name="ava1" class="pa-2" slot="item" slot-scope="{item}">
            <v-avatar left>
                <v-img v-bind:src="item.image" aspect-ratio="1"> </v-img>
            </v-avatar>
            {{item.oem}} - {{item.fcc}} - {{item.ic}}
        </v-list-tile>
      </v-autocomplete>
    </v-col>
    <v-col cols="1">

    </v-col>
  </v-row>
    <v-row v-if="key != null">
      <v-col cols="1"></v-col>
      <v-col cols="10">
        <v-card>
        <v-card-title style="height:50px;margin-top:-3% !important;">
          Inventory:
          <div style="margin-left:10px">
          <v-chip outlined color="primary">{{key.oem}}</v-chip> -
          <v-chip outlined color="primary">{{key.fcc}}</v-chip> -
          <v-chip outlined color="primary">{{key.ic}}</v-chip>
          </div>
        </v-card-title>
        <v-divider></v-divider>
        <v-row v-for="(loc) in locations"  :key="loc.key" style="margin-left:4%;min-height:50px">
          <v-col cols="2" class="text-info">{{loc.name}}:</v-col>
          <v-col cols="6" v-if="item != null">
            <b-button v-if="getLocationStock(loc.id) == 0" size="sm" variant="danger">Out of Stock</b-button>
            <b-button v-else size="sm" variant="info">{{getLocationStock(loc.id)}} in Stock</b-button>
          </v-col>
        </v-row>
      </v-card>
      </v-col>
      <v-col cols="1"></v-col>
    </v-row>
</div>
</template>

<script>
export default {
  created() {
    this.locations = this.$store.state.token.locations;
  },
  data: () => ({
    locations: [],
    keys: [],
    key: null,
    item: null,
    values: [],
    search:'',
    request: {
      oem: ''
    },
    loading: false,
    
    
  }),
  watch:{
    search(val){
      if(this.loading) return;
      if(val == '' || val == null) return;
      this.loading = true;
      this.$api.searchKey(val).then((response) => {
          if (response.status == 200)
              this.keys = response.data;
          this.loading = false;
      }).then(error => {
          this.loading = false;
      })
    }
  },
  methods: {
    input(val) {
      if (val != null) {
        this.request.oem = this.key.oem;
        this.$api.searchItem(this.request).then((response) => {
          if (response.status = 200) {
            this.item = response.data;
          }
        }).catch(error => {

        })
      }
    },
    getLocationStock(id) {
      if (this.item != null) {
        let x = -1;
        for (let i = 0; i < this.item.locations.length; i++)
          if (this.item.locations[i].location.id == id) {
            x = i;
            break;
          }
        if (x == -1)
          return "0";
        else
          return this.item.locations[x].amount;
      }
    }
  }
}
</script>
